import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", {
		fill: "currentColor",
		points: "13.3520038 0.333333333 14 0.822239776 7 7.33333333 0 0.822239776 0.647996187 0.333333333 7 6.2416892"
	})
});
export default SvgChevronDown;
